var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('router-link',{attrs:{"to":{ name: 'profile', params: { id: _vm.author.user_id } }}},[_vm._v("\n    "+_vm._s(_vm.author.name)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }